import { Typography } from 'fronton-react';
import React from 'react';
import { errorStateImage, errorStateTitle, errorStateWrapper } from './styles';
import { useTranslation } from 'react-i18next';

export const ERROR_STATE_DATA_QA = 'certificate-error-state';

export const ErrorState = () => {
  const { t } = useTranslation();

  return (
    <div data-qa={ERROR_STATE_DATA_QA} className={errorStateWrapper}>
      <img
        className={errorStateImage}
        src="https://cdn.lemanapro.ru/lmru/image/upload/v1785174760/fudzi/navigation-microfronts/pdp/error-state-image.svg/error-state-image.svg"
        width={160}
        height={104}
      />
      <Typography className={errorStateTitle} variant="h2">
        {t('product-info.manuals.error-state.title')}
      </Typography>
      <Typography size="body_long" variant="m">
        {t('product-info.manuals.error-state.sorry')}
      </Typography>
      <Typography size="body_long" variant="m">
        {t('product-info.manuals.error-state.retry')}
      </Typography>
    </div>
  );
};
